module.exports = __webpack_public_path__ + "static/img/logoOne.d39a8cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/logoOne.png
// module id = T7LC
// module chunks = 0